/**
 * Normalize Konva.Node geometry to core format
 * @param {Konva.Node} node
 */
export function normalizeGeometry(node) {
    const scaleX = node.scaleX()
    const scaleY = node.scaleY()

    const width = Math.max(node.width() * scaleX, 1)
    const height = Math.max(node.height() * scaleY, 1)
    node.scaleX(1)
    node.scaleY(1)
    node.width(width)
    node.height(height)

    return {
        x: node.x(),
        y: node.y(),
        width,
        height,
        rotation: node.rotation(),
    }
}
